(function () {
  // Menu mobile
  var toggle = document.querySelector('[data-ga-menu-toggle]');
  var nav = document.getElementById('ga-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Quantità +/-
  document.querySelectorAll('[data-ga-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    box.querySelector('[data-ga-qty-minus]').addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    box.querySelector('[data-ga-qty-plus]').addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 0) + 1;
    });
  });

  // Prezzo per variante
  document.querySelectorAll('[data-ga-variant]').forEach(function (select) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var price = select.closest('.ga-product').querySelector('[data-ga-price]');
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    });
  });
})();
